import AccountBusinessSearch from './accountBusinessSearch'

export default [
  {
    path: '/null',
    component: () => import('@/components'),
    children: [
      ...AccountBusinessSearch
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/accountBusinessManage/index.js